export const GOLD_IRA_PATH = "gold-ira";

export const BI_SITE_CONFIGURATION = {
	[GOLD_IRA_PATH]: {
		preventRenderingCompanyListHeader: true,
		showFeaturedCompany: true,
	},
};
